import { height } from "@mui/system";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { enqueueSnackbar } from "notistack";

export const html2pdf = async (renderedHTML : string) => {
    // create div container
    const element = document.createElement("div");
    // set id attribute for getting html element
    element.setAttribute("id","pdf-container");
    element.innerHTML = renderedHTML;

    if(!window) return; // it checks for server side
    document.body.append(element);

    const container = document.getElementById("pdf-container");
    
    try {
        const canvas = await html2canvas(container, { scale: 2 , height : 1736 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        document.getElementById("pdf-container")?.remove()
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight , undefined , 'FAST');
        pdf.save("rendered.pdf");
    } catch (error) {
        enqueueSnackbar(error.toString(), {
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'error',
          });
    }
   
}